module.exports = __webpack_public_path__ + "static/media/head-back.be57e872.png";